var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c(_vm.currentComponent,{key:_vm.$route.name,tag:"component"}),_c('NavInternal',{attrs:{"links":_vm.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }